import DashboardChartResponsibleFilter from "./DashboardChartResponsibleFilter";

export default DashboardChartResponsibleFilter;
